import Vue from 'vue';
import { defineComponent, ref, computed, provide, watchEffect, h, inject, reactive } from '@vue/composition-api';
import { MountingPortal } from 'portal-vue';
import ClientOnly from 'vue-client-only';

// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
function isPlainObject(value) {
    return Object.prototype.toString.call(value) === '[object Object]';
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function isObject(obj) {
    return obj !== null && typeof obj === 'object';
}
function mergeDeep(
/* eslint-disable @typescript-eslint/no-explicit-any */
source, target) {
    if (source === void 0) { source = {}; }
    if (target === void 0) { target = {}; }
    /* eslint-enable @typescript-eslint/no-explicit-any */
    for (var key in target) {
        var sourceProperty = source[key];
        var targetProperty = target[key];
        if (isObject(sourceProperty) && isObject(targetProperty)) {
            source[key] = mergeDeep(sourceProperty, targetProperty);
            continue;
        }
        source[key] = targetProperty;
    }
    return source;
}
var allowedKeys = [
    'key',
    'slot',
    'scopedSlots',
    'ref',
    'refInFor',
    'tag',
    'staticClass',
    'class',
    'staticStyle',
    'style',
    'props',
    'attrs',
    'domProps',
    'on',
    'nativeOn',
    'directives',
    'keepAlive',
];
/**
 * Filter object to keep only VNodeData keys accepted in `h`
 */
function filterVueData(data) {
    if (data === void 0) { data = {}; }
    var res = {};
    Object.keys(data)
        .filter(function (key) { return allowedKeys.includes(key); })
        .forEach(function (key) {
        res[key] = data[key];
    });
    return res;
}

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}

var e=function(){return (e=Object.assign||function(e){for(var t,r=1,s=arguments.length;r<s;r++)for(var a in t=arguments[r])Object.prototype.hasOwnProperty.call(t,a)&&(e[a]=t[a]);return e}).apply(this,arguments)},t={kebab:/-(\w)/g,styleProp:/:(.*)/,styleList:/;(?![^(]*\))/g};function r(e,t){return t?t.toUpperCase():""}function s(e){for(var s,a={},c=0,o=e.split(t.styleList);c<o.length;c++){var n=o[c].split(t.styleProp),i=n[0],l=n[1];(i=i.trim())&&("string"==typeof l&&(l=l.trim()),a[(s=i,s.replace(t.kebab,r))]=l);}return a}function a(){for(var t,r,a={},c=arguments.length;c--;)for(var o=0,n=Object.keys(arguments[c]);o<n.length;o++)switch(t=n[o]){case"class":case"style":case"directives":if(Array.isArray(a[t])||(a[t]=[]),"style"===t){var i=void 0;i=Array.isArray(arguments[c].style)?arguments[c].style:[arguments[c].style];for(var l=0;l<i.length;l++){var y=i[l];"string"==typeof y&&(i[l]=s(y));}arguments[c].style=i;}a[t]=a[t].concat(arguments[c][t]);break;case"staticClass":if(!arguments[c][t])break;void 0===a[t]&&(a[t]=""),a[t]&&(a[t]+=" "),a[t]+=arguments[c][t].trim();break;case"on":case"nativeOn":a[t]||(a[t]={});for(var p=0,f=Object.keys(arguments[c][t]||{});p<f.length;p++)r=f[p],a[t][r]?a[t][r]=[].concat(a[t][r],arguments[c][t][r]):a[t][r]=arguments[c][t][r];break;case"attrs":case"props":case"domProps":case"scopedSlots":case"staticStyle":case"hook":case"transition":a[t]||(a[t]={}),a[t]=e({},arguments[c][t],a[t]);break;case"slot":case"key":case"ref":case"tag":case"show":case"keepAlive":default:a[t]||(a[t]=arguments[c][t]);}return a}

// eslint-disable-next-line @typescript-eslint/no-unused-vars, @typescript-eslint/no-empty-function
var warn = function (msg) { };
if (process.env.NODE_ENV !== 'production') {
    warn = function (msg) {
        console === null || console === void 0 ? void 0 : console.warn("[Ch\u016Bsh\u014D warn]: " + msg);
    };
}

var CBtn = Vue.extend({
    name: 'CBtn',
    functional: true,
    props: {
        /**
         * Make the button a link to the given location
         */
        href: {
            type: String,
            default: null,
        },
        /**
         * Use a `router-link` (or `nuxt-link` in a Nuxt app) in the background, works juste like the `router-link` prop of the same name.
         *
         * Note that you can also pass all other `router-link` props such as `activeClass`, `replace`, … See [Vue router documentation](https://router.vuejs.org/api/#router-link) for a complete list of available props.
         */
        to: {
            type: [String, Object],
            default: null,
        },
        /**
         * In case the Btn is a `button` element, specify its type
         */
        type: {
            type: String,
            default: 'button',
        },
        /**
         * Customize the button appearance by applying one or multiple variants defined in the config (btn.variants). Multiple variants should be separated by a space.
         *
         * Example: `"primary large"`
         */
        variant: {
            type: String,
            default: '',
        },
        /**
         * Disable the button (doesn’t apply to links) and apply the associated class from the config (btn.disabledClass).
         */
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    render: function (h, _a) {
        var _b, _c, _d;
        var props = _a.props, data = _a.data, parent = _a.parent, children = _a.children;
        var btnConfig = (_d = (_c = (_b = parent === null || parent === void 0 ? void 0 : parent.$chusho) === null || _b === void 0 ? void 0 : _b.options) === null || _c === void 0 ? void 0 : _c.components) === null || _d === void 0 ? void 0 : _d.btn;
        var classes = [];
        var tag = 'button';
        var attrs = {};
        if (props.to) {
            tag = parent.$nuxt ? 'nuxt-link' : 'router-link';
            attrs = {
                to: props.to,
            };
        }
        else if (props.href) {
            tag = 'a';
            attrs = {
                href: props.href,
            };
        }
        if (btnConfig) {
            if (btnConfig.defaultClass) {
                classes.push(btnConfig.defaultClass);
            }
            if (btnConfig.disabledClass && props.disabled) {
                classes.push(btnConfig.disabledClass);
            }
            if (props.variant) {
                var variants = props.variant.split(' ');
                variants.forEach(function (variant) {
                    var _a;
                    var target = (_a = btnConfig === null || btnConfig === void 0 ? void 0 : btnConfig.variants) === null || _a === void 0 ? void 0 : _a[variant];
                    if (target) {
                        classes.push(target);
                    }
                    else {
                        warn("Cannot find an Button variant named \u201C" + variant + "\u201D under \u201Cbutton.variants\u201D defined in the config, you must define it before referencing it.");
                    }
                });
            }
        }
        var componentData = {
            attrs: __assign(__assign(__assign({}, attrs), (props.disabled && tag === 'button' && { disabled: true })), (props.type && tag === 'button' && { type: props.type })),
        };
        if (classes.length) {
            componentData.class = classes;
        }
        return h(tag, a(data, componentData), children);
    },
});

var currentUuid = 0;
function uuid() {
    return currentUuid++;
}

var CIcon = Vue.extend({
    name: 'CIcon',
    functional: true,
    props: {
        /**
         * The id of the symbol (icon) to display from within the sprite.
         */
        id: {
            type: String,
            required: true,
        },
        /**
         * The scale relative to the dimensions defined in the config (icon.width, icon.height).
         */
        scale: {
            type: Number,
            default: 1,
        },
        /**
         * Provides an alternate text to describe the icon meaning in the context its used.
         * In cases where an icon would be used without any label close by, this is important
         * to provide for accessibility.
         *
         * Example: imagine a lonely trash icon within a button dedicated to delete an article,
         * this prop should be set to a value like "Delete article".
         */
        alt: {
            type: String,
            default: '',
        },
    },
    render: function (h, _a) {
        var _b, _c, _d;
        var props = _a.props, data = _a.data, parent = _a.parent;
        var iconConfig = (_d = (_c = (_b = parent === null || parent === void 0 ? void 0 : parent.$chusho) === null || _b === void 0 ? void 0 : _b.options) === null || _c === void 0 ? void 0 : _c.components) === null || _d === void 0 ? void 0 : _d.icon;
        var componentData = {
            attrs: {
                focusable: 'false',
            },
            style: {
                width: ((iconConfig === null || iconConfig === void 0 ? void 0 : iconConfig.width) || 24) * props.scale + "px",
                height: ((iconConfig === null || iconConfig === void 0 ? void 0 : iconConfig.height) || 24) * props.scale + "px",
            },
        };
        var uid = "chusho-icon-" + uuid();
        if (iconConfig === null || iconConfig === void 0 ? void 0 : iconConfig.class) {
            componentData.class = iconConfig.class;
        }
        if (componentData.attrs) {
            if (props.alt) {
                componentData.attrs['aria-labelledby'] = uid;
            }
            else {
                componentData.attrs['aria-hidden'] = true;
            }
        }
        return h('svg', a(data, componentData), [
            props.alt &&
                h('title', {
                    attrs: {
                        id: uid,
                    },
                }, [props.alt]),
            h('use', {
                key: props.id,
                attrs: {
                    'xlink:href': ((iconConfig === null || iconConfig === void 0 ? void 0 : iconConfig.spriteUrl) || '') + "#" + props.id,
                },
            }),
        ]);
    },
});

var ToggleSymbol = Symbol();
var CToggle = defineComponent({
    name: 'CToggle',
    model: {
        prop: 'open',
        event: 'toggle',
    },
    props: {
        /**
         * Optionally bind the Toggle state with the parent component.
         */
        open: {
            type: Boolean,
            default: undefined,
        },
    },
    setup: function (props, _a) {
        var slots = _a.slots, emit = _a.emit;
        var open = ref(false);
        function toggle() {
            open.value = !open.value;
            // Update potential parent v-model value
            emit('toggle', open.value);
        }
        // Provide api to sub-components
        var api = {
            uuid: uuid(),
            open: computed(function () { return open.value; }),
            toggle: toggle,
        };
        provide(ToggleSymbol, api);
        // Watch potential parent v-model value changes and update state accordingly
        watchEffect(function () {
            if (typeof props.open === 'boolean') {
                open.value = props.open;
            }
        });
        return function () { return h('div', slots.default && slots.default()); };
    },
});

var CToggleBtn = defineComponent({
    name: 'CToggleBtn',
    inheritAttrs: false,
    setup: function (props, _a) {
        var attrs = _a.attrs, slots = _a.slots, listeners = _a.listeners;
        var toggle = inject(ToggleSymbol);
        return function () {
            var componentData = {
                attrs: __assign(__assign({}, attrs), { 'aria-expanded': "" + toggle.open.value, 'aria-controls': "chusho-toggle-" + toggle.uuid }),
                on: __assign(__assign({}, listeners), { click: function () {
                        toggle.toggle();
                    } }),
            };
            return h(CBtn, componentData, slots.default());
        };
    },
});

var CToggleContent = defineComponent({
    name: 'CToggleContent',
    inheritAttrs: false,
    props: {
        /**
         * The object can contain any Vue built-in [transition component props](https://vuejs.org/v2/api/#transition).
         *
         * For example: `{ name: "fade", mode: "out-in" }`.
         *
         * If you defined a default transition in the config and want to disable it, use `false`.
         */
        transition: {
            type: [Object, Boolean],
            default: null,
        },
    },
    setup: function (props, _a) {
        var _b, _c, _d;
        var slots = _a.slots, attrs = _a.attrs, parent = _a.parent;
        var toggleConfig = (_d = (_c = (_b = parent.$chusho) === null || _b === void 0 ? void 0 : _b.options) === null || _c === void 0 ? void 0 : _c.components) === null || _d === void 0 ? void 0 : _d.toggle;
        var toggle = inject(ToggleSymbol);
        var transition;
        if (isPlainObject(props.transition)) {
            transition = props.transition;
        }
        else if (props.transition !== false &&
            toggleConfig &&
            toggleConfig.transition) {
            transition = toggleConfig.transition;
        }
        function renderContent() {
            if (toggle.open.value) {
                return h('div', {
                    attrs: __assign(__assign({}, attrs), { id: "chusho-toggle-" + toggle.uuid }),
                }, slots.default());
            }
            return null;
        }
        return function () {
            if (!transition)
                return renderContent();
            return h('transition', { props: transition }, [renderContent()]);
        };
    },
});

var FlexSymbol = Symbol();
var CFlex = defineComponent({
    name: 'CFlex',
    props: {
        /**
         * One of the gaps defined in the config (flex.gaps) to apply to the element.
         *
         * A value of type string apply the same gap on both axis. Use an array of type `[x, y]` to have a different gap between columns and rows.
         */
        gap: {
            type: [String, Number, Array],
            default: null,
        },
    },
    setup: function (props, _a) {
        var _b, _c, _d, _e, _f;
        var attrs = _a.attrs, slots = _a.slots, parent = _a.parent;
        var flexConfig = (_b = parent.$chusho.options.components) === null || _b === void 0 ? void 0 : _b.flex;
        var gapXKey = props.gap instanceof Array ? props.gap[0] : props.gap;
        var gapYKey = props.gap instanceof Array ? props.gap[1] : props.gap;
        var gapX = gapXKey ? (_d = (_c = flexConfig === null || flexConfig === void 0 ? void 0 : flexConfig.gaps) === null || _c === void 0 ? void 0 : _c.x) === null || _d === void 0 ? void 0 : _d[gapXKey] : undefined;
        var gapY = gapYKey ? (_f = (_e = flexConfig === null || flexConfig === void 0 ? void 0 : flexConfig.gaps) === null || _e === void 0 ? void 0 : _e.y) === null || _f === void 0 ? void 0 : _f[gapYKey] : undefined;
        var api = {
            gapX: gapX,
            gapY: gapY,
        };
        provide(FlexSymbol, api);
        if (props.gap && !gapX) {
            warn("Cannot find a Flex gap named \"" + gapXKey + "\" under \"flex.gaps.x\" defined in the config, you must define it before referencing it.");
        }
        if (props.gap && !gapY) {
            warn("Cannot find a Flex gap named \"" + gapYKey + "\" under \"flex.gaps.y\" defined in the config, you must define it before referencing it.");
        }
        return function () {
            var componentData = a(__assign({}, attrs), {
                class: [
                    flexConfig === null || flexConfig === void 0 ? void 0 : flexConfig.containerClass,
                    gapX === null || gapX === void 0 ? void 0 : gapX.containerClass,
                    gapY === null || gapY === void 0 ? void 0 : gapY.containerClass,
                ],
            });
            return h('div', componentData, slots.default && slots.default());
        };
    },
});

var CFlexItem = defineComponent({
    name: 'CFlexItem',
    props: {
        /**
         * One or more widths defined in the config (flex.widths) to apply to the element.
         *
         * Single default value: `width="1/2"`
         *
         * Multiple values: `:width="{ default: '1/2', sm: '1/3', md: '1/4' }"`
         *
         * Except the `default` key which acts like the single value, all others (`sm` & `md` here) are totally up to you. They should probably match your own breakpoints naming though.
         *
         * You can change how responsive classes are generated by defining a custom `flex.responsiveWidthGenerator` function in the config.
         */
        width: {
            type: [String, Object],
        },
    },
    setup: function (props, _a) {
        var _b;
        var slots = _a.slots, attrs = _a.attrs, parent = _a.parent;
        var chushoOptions = parent.$chusho.options;
        var flexConfig = (_b = chushoOptions.components) === null || _b === void 0 ? void 0 : _b.flex;
        var flex = inject(FlexSymbol);
        var widthClasses = [];
        var widths = {};
        if (isPlainObject(props.width)) {
            widths = props.width;
        }
        else if (props.width) {
            widths = {
                default: props.width,
            };
        }
        if (props.width) {
            Object.keys(widths).forEach(function (breakpoint) {
                var _a;
                var value = widths[breakpoint];
                var width = (_a = flexConfig === null || flexConfig === void 0 ? void 0 : flexConfig.widths) === null || _a === void 0 ? void 0 : _a[value];
                if (width) {
                    if (breakpoint === 'default') {
                        widthClasses.push(width);
                        return;
                    }
                    widthClasses.push(chushoOptions.components.flex.responsiveWidthGenerator(breakpoint, width));
                }
                else {
                    warn("Cannot find a Flex width named \"" + value + "\" defined under \"flex.widths\" in the config, you must define it before referencing it.");
                }
            });
        }
        if (!widths.default && (flexConfig === null || flexConfig === void 0 ? void 0 : flexConfig.defaultWidth)) {
            widthClasses.push(flexConfig.defaultWidth);
        }
        return function () {
            var _a, _b;
            var componentData = a(__assign({}, attrs), {
                class: __spreadArrays(widthClasses, [
                    flexConfig === null || flexConfig === void 0 ? void 0 : flexConfig.itemClass,
                    (_a = flex.gapX) === null || _a === void 0 ? void 0 : _a.itemClass,
                    (_b = flex.gapY) === null || _b === void 0 ? void 0 : _b.itemClass,
                ]),
            });
            return h('div', componentData, slots.default && slots.default());
        };
    },
});

var TabsMixin = {
    props: {
        /**
         * Disable class inheritance from the component config.
         */
        bare: {
            type: Boolean,
            default: false,
        },
    },
};

var TabsSymbol = Symbol();
var CTabs = defineComponent({
    name: 'CTabs',
    mixins: [TabsMixin],
    model: {
        prop: 'currentTab',
        event: 'change',
    },
    props: {
        /**
         * Optionally bind the Tabs state with the parent component.
         */
        currentTab: {
            type: [Number, String],
            default: null,
        },
        /**
         * The id of the Tab to display by default. This will be ignored if `v-model` is used.
         *
         * Defaults to the first tab.
         */
        defaultTab: {
            type: [Number, String],
            default: null,
        },
    },
    setup: function (props, _a) {
        var _b, _c, _d;
        var slots = _a.slots, attrs = _a.attrs, parent = _a.parent, emit = _a.emit;
        var tabsConfig = (_d = (_c = (_b = parent.$chusho) === null || _b === void 0 ? void 0 : _b.options) === null || _c === void 0 ? void 0 : _c.components) === null || _d === void 0 ? void 0 : _d.tabs;
        var state = reactive({
            currentTab: props.currentTab || props.defaultTab,
            tabs: [],
        });
        function setCurrentTab(id) {
            state.currentTab = id;
            // Update potential parent v-model value
            emit('change', id);
        }
        function registerTab(id) {
            state.tabs.push(id);
            if (state.tabs.length === 1 && !state.currentTab) {
                state.currentTab = id;
            }
        }
        // Provide api to sub-components
        var api = {
            uuid: uuid(),
            currentTab: computed(function () { return state.currentTab; }),
            tabs: computed(function () { return state.tabs; }),
            setCurrentTab: setCurrentTab,
            registerTab: registerTab,
        };
        provide(TabsSymbol, api);
        // Watch potential parent v-model value changes and update state accordingly
        watchEffect(function () {
            if (props.currentTab) {
                state.currentTab = props.currentTab;
            }
        });
        var componentData = {
            attrs: attrs,
            class: props.bare ? null : tabsConfig === null || tabsConfig === void 0 ? void 0 : tabsConfig.tabsClass,
        };
        return function () {
            return h('div', componentData, slots.default && slots.default());
        };
    },
});

function getSiblingIndexByArrowKey(list, current, key, rtl) {
    var currentIndex = list.indexOf(current);
    var index = currentIndex > -1 ? currentIndex : 0;
    var right = ['ArrowRight', 'Right'];
    var left = ['ArrowLeft', 'Left'];
    var newIndex;
    if ((left.includes(key) && rtl) || (right.includes(key) && !rtl)) {
        newIndex = index === list.length - 1 ? 0 : index + 1;
    }
    else if ((left.includes(key) && !rtl) || (right.includes(key) && rtl)) {
        newIndex = index === 0 ? list.length - 1 : index - 1;
    }
    else if (key === 'Home') {
        newIndex = 0;
    }
    else if (key === 'End') {
        newIndex = list.length - 1;
    }
    return newIndex;
}
function getFocusableElements(el) {
    // List courtesy of a11y-dialog
    // https://github.com/edenspiekermann/a11y-dialog
    var focusableEls = el.querySelectorAll([
        'a[href]:not([tabindex^="-"]):not([inert])',
        'area[href]:not([tabindex^="-"]):not([inert])',
        'input:not([disabled]):not([inert])',
        'select:not([disabled]):not([inert])',
        'textarea:not([disabled]):not([inert])',
        'button:not([disabled]):not([inert])',
        'iframe:not([tabindex^="-"]):not([inert])',
        'audio:not([tabindex^="-"]):not([inert])',
        'video:not([tabindex^="-"]):not([inert])',
        '[contenteditable]:not([tabindex^="-"]):not([inert])',
        '[tabindex]:not([tabindex^="-"]):not([inert])',
    ].join(','));
    return Array.from(focusableEls);
}

var CTabList = defineComponent({
    name: 'CTabList',
    mixins: [TabsMixin],
    props: {},
    setup: function (props, _a) {
        var _b, _c, _d;
        var attrs = _a.attrs, slots = _a.slots, parent = _a.parent, refs = _a.refs;
        var tabsConfig = (_d = (_c = (_b = parent.$chusho) === null || _b === void 0 ? void 0 : _b.options) === null || _c === void 0 ? void 0 : _c.components) === null || _d === void 0 ? void 0 : _d.tabs;
        var tabs = inject(TabsSymbol);
        function handleNavigation(e) {
            var _a, _b;
            if (!tabs.currentTab.value)
                return;
            var activeTabIndex = tabs.tabs.value.indexOf(tabs.currentTab.value);
            var activeTabId = tabs.tabs.value[activeTabIndex];
            var rtl = (_b = (_a = parent.$chusho) === null || _a === void 0 ? void 0 : _a.options) === null || _b === void 0 ? void 0 : _b.rtl;
            var newIndex = getSiblingIndexByArrowKey(tabs.tabs.value, activeTabId, e.key, rtl && rtl());
            if (newIndex !== undefined) {
                e.preventDefault();
                tabs.setCurrentTab(tabs.tabs.value[newIndex]);
                Vue.nextTick(function () {
                    if (refs && refs.tabList && refs.tabList instanceof Element) {
                        var activeTab = refs.tabList.querySelector('[aria-selected="true"]');
                        if (activeTab) {
                            activeTab.focus();
                        }
                    }
                });
            }
        }
        return function () {
            var componentData = {
                attrs: __assign(__assign({}, attrs), { role: 'tablist' }),
                class: props.bare ? null : tabsConfig === null || tabsConfig === void 0 ? void 0 : tabsConfig.tabListClass,
                on: {
                    keydown: handleNavigation,
                },
                ref: 'tabList',
            };
            return h('div', componentData, slots.default && slots.default());
        };
    },
});

var CTab = defineComponent({
    name: 'CTab',
    mixins: [TabsMixin],
    props: {
        /**
         * The id of the Tab this button should control.
         */
        target: {
            type: [Number, String],
            required: true,
        },
        /**
         * Generate class based on the current component state. It should return a valid Vue “class” syntax (object, array or string), see [Vue class documentation](https://vuejs.org/v2/guide/class-and-style.html).
         *
         * For example: `(active) => ({ 'btn': true, 'btn--active': active })`
         */
        classGenerator: {
            type: Function,
        },
    },
    setup: function (props, _a) {
        var _b, _c, _d;
        var attrs = _a.attrs, parent = _a.parent, slots = _a.slots;
        var tabsConfig = (_d = (_c = (_b = parent.$chusho) === null || _b === void 0 ? void 0 : _b.options) === null || _c === void 0 ? void 0 : _c.components) === null || _d === void 0 ? void 0 : _d.tabs;
        var tabs = inject(TabsSymbol);
        return function () {
            var isActive = props.target === tabs.currentTab.value;
            var componentData = {
                attrs: __assign(__assign({}, attrs), { type: 'button', id: "chusho-tabs-" + tabs.uuid + "-tab-" + props.target, role: 'tab', 'aria-selected': "" + isActive, 'aria-controls': "chusho-tabs-" + tabs.uuid + "-tabpanel-" + props.target, tabindex: isActive ? '0' : '-1' }),
                class: [],
                on: {
                    click: function () {
                        if (!props.target)
                            return;
                        tabs.setCurrentTab(props.target);
                    },
                },
            };
            if (!props.bare) {
                if (tabsConfig === null || tabsConfig === void 0 ? void 0 : tabsConfig.tabClass) {
                    if (typeof tabsConfig.tabClass === 'function') {
                        componentData.class.push(tabsConfig.tabClass(isActive));
                    }
                    else {
                        componentData.class.push(tabsConfig.tabClass);
                    }
                }
            }
            if (props.classGenerator) {
                componentData.class.push(props.classGenerator(isActive));
            }
            return h('button', componentData, slots.default && slots.default());
        };
    },
});

var CTabPanels = defineComponent({
    name: 'CTabPanels',
    mixins: [TabsMixin],
    props: {},
    setup: function (props, _a) {
        var _b, _c, _d;
        var attrs = _a.attrs, parent = _a.parent, slots = _a.slots;
        var tabsConfig = (_d = (_c = (_b = parent.$chusho) === null || _b === void 0 ? void 0 : _b.options) === null || _c === void 0 ? void 0 : _c.components) === null || _d === void 0 ? void 0 : _d.tabs;
        return function () {
            var componentData = {
                attrs: attrs,
                class: props.bare ? null : tabsConfig === null || tabsConfig === void 0 ? void 0 : tabsConfig.tabPanelsClass,
            };
            return h('div', componentData, slots.default && slots.default());
        };
    },
});

var CTabPanel = defineComponent({
    name: 'CTabPanel',
    mixins: [TabsMixin],
    props: {
        /**
         * A unique ID to target the Tab.
         */
        id: {
            type: [Number, String],
            required: true,
        },
        /**
         * Generate classes based on the current component state. It should return a valid Vue “class” syntax (object, array or string), see [Vue class documentation](https://vuejs.org/v2/guide/class-and-style.html).
         *
         * For example: `(active) => ({ 'tab-panel': true, 'tab-panel--active': active })`
         */
        classGenerator: {
            type: Function,
        },
    },
    setup: function (props, _a) {
        var _b, _c, _d;
        var attrs = _a.attrs, parent = _a.parent, slots = _a.slots;
        var tabsConfig = (_d = (_c = (_b = parent.$chusho) === null || _b === void 0 ? void 0 : _b.options) === null || _c === void 0 ? void 0 : _c.components) === null || _d === void 0 ? void 0 : _d.tabs;
        var tabs = inject(TabsSymbol);
        tabs.registerTab(props.id);
        return function () {
            var isActive = props.id === tabs.currentTab.value;
            if (!isActive)
                return null;
            var componentData = {
                attrs: __assign(__assign({}, attrs), { id: "chusho-tabs-" + tabs.uuid + "-tabpanel-" + props.id, role: 'tabpanel', 'aria-labelledby': "chusho-tabs-" + tabs.uuid + "-tab-" + props.id, tabindex: '0' }),
                class: [],
            };
            if (!props.bare) {
                if (tabsConfig === null || tabsConfig === void 0 ? void 0 : tabsConfig.tabPanelClass) {
                    if (typeof tabsConfig.tabPanelClass === 'function') {
                        componentData.class.push(tabsConfig.tabPanelClass(isActive));
                    }
                    else {
                        componentData.class.push(tabsConfig.tabPanelClass);
                    }
                }
            }
            if (props.classGenerator) {
                componentData.class.push(props.classGenerator(isActive));
            }
            return h('div', componentData, slots.default && slots.default());
        };
    },
});

var PORTAL_ID = 'chusho-dialogs-portal';
var KEY_TAB = 9;
var KEY_ESC = 27;
var CDialog = Vue.extend({
    name: 'CDialog',
    model: {
        prop: 'open',
        event: 'toggle',
    },
    props: {
        /**
         * Control the Dialog state
         */
        open: {
            type: Boolean,
            required: true,
        },
        /**
         * The object can contain any Vue built-in [transition component props](https://vuejs.org/v2/api/#transition).
         *
         * For example: `{ name: "fade", mode: "out-in" }`.
         *
         * If you defined a default transition in the config and want to disable it, use `false`.
         */
        transition: {
            type: [Object, Boolean],
            default: null,
        },
    },
    data: function () {
        return {
            active: false,
            savedActiveElement: null,
            focusableElements: [],
        };
    },
    computed: {
        firstFocusableEl: function () {
            return this.focusableElements[0];
        },
        lastFocusableEl: function () {
            return this.focusableElements[this.focusableElements.length - 1];
        },
    },
    methods: {
        activate: function () {
            var _this = this;
            if (this.active)
                return;
            this.active = true;
            this.savedActiveElement = document.activeElement;
            // Store the dialog instance in a global array
            // This allow closing only the last one when pressing ESC and multiple dialogs are open
            this.$chusho.openDialogs.push(this);
            this.$nextTick(function () {
                var _a;
                _this.focusableElements = getFocusableElements(_this.$refs.dialog);
                (_a = _this.firstFocusableEl) === null || _a === void 0 ? void 0 : _a.focus();
                _this.preventAccessToPageContent();
            });
            document.addEventListener('keydown', this.handleKeyDown);
        },
        deactivate: function () {
            var _a;
            if (!this.active)
                return;
            this.releaseAccessToPageContent();
            var i = this.$chusho.openDialogs.indexOf(this);
            this.$chusho.openDialogs.splice(i, 1);
            (_a = this.savedActiveElement) === null || _a === void 0 ? void 0 : _a.focus();
            document.removeEventListener('keydown', this.handleKeyDown);
            this.active = false;
        },
        createPortalIfNotExists: function () {
            if (!document.getElementById(PORTAL_ID)) {
                var portalNode = document.createElement('div');
                portalNode.setAttribute('id', PORTAL_ID);
                document.body.insertAdjacentElement('beforeend', portalNode);
            }
        },
        getPortalNodeSiblings: function () {
            return Array.from(document.body.children).filter(function (el) {
                // Ignore already non-visible elements such as <script>
                return el.offsetParent !== null && el.id != PORTAL_ID;
            });
        },
        preventAccessToPageContent: function () {
            this.getPortalNodeSiblings().forEach(function (el) {
                el.setAttribute('aria-hidden', 'true');
            });
        },
        releaseAccessToPageContent: function () {
            this.getPortalNodeSiblings().forEach(function (el) {
                el.removeAttribute('aria-hidden');
            });
        },
        handleKeyDown: function (e) {
            switch (e.keyCode) {
                case KEY_ESC:
                    if (this ===
                        this.$chusho.openDialogs[this.$chusho.openDialogs.length - 1]) {
                        this.$emit('toggle', false);
                    }
                    break;
                case KEY_TAB:
                    if (this.focusableElements.length === 1) {
                        e.preventDefault();
                    }
                    else if (e.shiftKey) {
                        if (this.lastFocusableEl &&
                            document.activeElement === this.firstFocusableEl) {
                            e.preventDefault();
                            this.lastFocusableEl.focus();
                        }
                    }
                    else {
                        if (this.firstFocusableEl &&
                            document.activeElement === this.lastFocusableEl) {
                            e.preventDefault();
                            this.firstFocusableEl.focus();
                        }
                    }
                    break;
            }
        },
    },
    render: function (h) {
        var _this = this;
        var _a, _b, _c, _d;
        var dialogConfig = (_d = (_c = (_b = (_a = this.$parent) === null || _a === void 0 ? void 0 : _a.$chusho) === null || _b === void 0 ? void 0 : _b.options) === null || _c === void 0 ? void 0 : _c.components) === null || _d === void 0 ? void 0 : _d.dialog;
        var children = [];
        // Do not render dialogs on the server
        if (!this.$isServer) {
            this.createPortalIfNotExists();
            if (this.open) {
                var overlayData = {
                    attrs: {
                        tabindex: '-1',
                    },
                    on: {
                        click: function (e) {
                            if (e.target !== e.currentTarget)
                                return;
                            _this.$emit('toggle', false);
                        },
                    },
                };
                var dialogData = {
                    attrs: {
                        role: 'dialog',
                    },
                    ref: 'dialog',
                };
                if (dialogConfig === null || dialogConfig === void 0 ? void 0 : dialogConfig.overlayClass) {
                    overlayData.class = dialogConfig.overlayClass;
                }
                if (dialogConfig === null || dialogConfig === void 0 ? void 0 : dialogConfig.dialogClass) {
                    dialogData.class = dialogConfig.dialogClass;
                }
                children.push(h('div', overlayData, [
                    h('div', a(filterVueData(this.$vnode.data), dialogData), this.$slots.default),
                ]));
                this.$nextTick(this.activate);
            }
            else {
                this.$nextTick(this.deactivate);
            }
            var transition = void 0;
            if (isPlainObject(this.transition)) {
                transition = this.transition;
            }
            else if (this.transition !== false &&
                dialogConfig &&
                dialogConfig.transition) {
                transition = dialogConfig.transition;
            }
            if (transition) {
                children = [
                    h('transition', {
                        props: transition,
                        key: 'transition',
                    }, children),
                ];
            }
        }
        return h(ClientOnly, [
            h(MountingPortal, {
                props: {
                    append: true,
                    mountTo: "#" + PORTAL_ID,
                },
            }, children),
        ]);
    },
});

var CAlert = Vue.extend({
    name: 'CAlert',
    functional: true,
    props: {
        /**
         * Customize the alert appearance by applying a variant defined in the config (alert.variants).
         */
        variant: {
            type: String,
            default: null,
        },
    },
    render: function (h, _a) {
        var _b, _c, _d;
        var props = _a.props, data = _a.data, parent = _a.parent, children = _a.children;
        var alertConfig = (_d = (_c = (_b = parent === null || parent === void 0 ? void 0 : parent.$chusho) === null || _b === void 0 ? void 0 : _b.options) === null || _c === void 0 ? void 0 : _c.components) === null || _d === void 0 ? void 0 : _d.alert;
        var classes = [];
        if (alertConfig) {
            if (alertConfig.defaultClass) {
                classes.push(alertConfig.defaultClass);
            }
            if (props.variant) {
                var variants = props.variant.split(' ');
                variants.forEach(function (variant) {
                    var _a;
                    var target = (_a = alertConfig === null || alertConfig === void 0 ? void 0 : alertConfig.variants) === null || _a === void 0 ? void 0 : _a[variant];
                    if (target) {
                        classes.push(target);
                    }
                    else {
                        warn("Cannot find an Alert variant named \u201C" + variant + "\u201D under \u201Calert.variants\u201D defined in the config, you must define it before referencing it.");
                    }
                });
            }
        }
        var componentData = {
            attrs: {
                role: 'alert',
            },
        };
        if (classes.length) {
            componentData.class = classes;
        }
        return h('div', a(data, componentData), children);
    },
});

var components = /*#__PURE__*/Object.freeze({
  __proto__: null,
  CBtn: CBtn,
  CIcon: CIcon,
  CToggle: CToggle,
  CToggleBtn: CToggleBtn,
  CToggleContent: CToggleContent,
  CFlex: CFlex,
  CFlexItem: CFlexItem,
  CTabs: CTabs,
  CTabList: CTabList,
  CTab: CTab,
  CTabPanels: CTabPanels,
  CTabPanel: CTabPanel,
  CDialog: CDialog,
  CAlert: CAlert
});

var defaultOptions = {
    rtl: function () {
        return document && document.dir === 'rtl';
    },
    components: {
        flex: {
            responsiveWidthGenerator: function (breakpoint, width) {
                return breakpoint + ":" + width;
            },
        },
    },
};
var Chusho = {
    install: function (Vue, userOptions) {
        var options = mergeDeep(defaultOptions, userOptions);
        // Provide configuration
        Vue.prototype.$chusho = {
            options: options,
            openDialogs: [],
        };
        // Install components
        var pluginComponents = components;
        Object.keys(pluginComponents).forEach(function (componentName) {
            Vue.component(componentName, pluginComponents[componentName]);
        });
    },
};
var utils = {
    mergeDeep: mergeDeep,
};

export default Chusho;
export { CAlert, CBtn, CDialog, CFlex, CFlexItem, CIcon, CTab, CTabList, CTabPanel, CTabPanels, CTabs, CToggle, CToggleBtn, CToggleContent, utils };
